// store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import uiReducer from "./slices/uiSlice";
import globalSettingsReducer from "./slices/globalSettingsSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage"; // localStorage as default storage

// Combine all slices into a root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  globalSettings: globalSettingsReducer,
});

// Persist configuration (only persisting `auth` slice)
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // only auth state will be stored in localStorage
};

// Wrap rootReducer with persistence logic
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Ignore redux-persist actions from serializable check warnings
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Export persistor to use in <PersistGate>
export const persistor = persistStore(store);
